<style scoped>
[contenteditable]:focus {
  outline: 0px solid transparent;
}

.tab-sheet {
  font-size: 10px;
  border-top: 0.5px solid #ccc;
  border-right: 0.5px solid #ccc;
  width: 100%;
  cursor: pointer;
}

.tab-sheet.active {
  border-top: 0;
}

.tab-sheet .text {
  padding: 5px 20px 5px 20px;
}

.bottom-nav {
  position: fixed;
  z-index: 10000;
  bottom: 0;
  left: 0;
  float: left;
  width: 100%;
  background-color: #fff;
}

.bottom-nav div {
  display: block;
  float: left;
  width: auto;
  cursor: pointer;
}

.spread-sheet {
  margin-bottom: 30px;
}

.sticky-menu {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 50px;
  height: 100%;
  border-right: 0.5px solid #ccc;
  background-color: #fff;
}

.menu-container {
  position: fixed;
  left: 50px;
  top: 64px;
  width: 250px;
  height: 100%;
  z-index: 10000;
  background-color: rgba(255, 255, 255, 0.9);
  border-right: 0.5px solid #ccc;
  font-size: 10px;
}

.menu-container .v-input {
  font-size: 10px !important;
}

.canvas-inner {
  height: inherit;
  width: 100%;
  /**background-image: linear-gradient(-225deg, #231557 0%, #44107A 29%, #FF1361 67%, #FFF800 100%);**/
  overflow: hidden;
}
.link {
  cursor: pointer;
}

.vue-grid-item {
  /**outline: 1px dashed rgba(170, 170, 170, 0.7);**/
  outline-offset: 0px;
}

.vue-grid-item:hover {
  outline: 0px solid #3b97e3 !important;
}

.layer-editor {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.layer-editor.active {
  border: 0px solid #ccc;
}
.active-link {
  border-radius: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.inactive-link {
  border-radius: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.v-menu__content {
  z-index: 800 !important;
}
</style>

<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      top="top"
      vertical="vertical"
    >
      {{ text }}
      <v-btn color="pink" flat @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
    <v-dialog
      v-if="subChart.hasDialog"
      :fullscreen="dialogFullscreen"
      :hide-overlay="dialogFullscreen"
      v-model="subChartDialog"
      v-bind:persistent="true"
      :width="dialogFullscreen ? '95%' : '800px'"
      :max-height="dialogFullscreen ? '100%' : '80%'"
      class="bg"
    >
      <v-toolbar v-if="!dialogFullscreen">
        <h1 class="pt-2">{{ dialogTitle }}</h1>
        <v-btn
          color="pink"
          fab
          dark
          small
          absolute
          middle
          right
          @click="mCloseSubChart()"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-btn
        v-if="dialogFullscreen"
        color="pink"
        fab
        dark
        small
        absolute
        middle
        right
        @click="mCloseSubChart()"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <TaybullLayout
        class="taybull-view-mode"
        v-if="subChart.chartData.expandToPageChart"
        :chart="subChart.chartData.expandToPageChart"
        :mode="'view'"
        style=""
      />
    </v-dialog>
    <div ref="printMe">
      <v-container
        fluid
        fill-height
        class="spread-sheet"
        style="
          padding-top: 0px;
          padding-left: 0px;
          padding-right: 0px;
          overflow-y: none;
          background-color: #fff;
        "
      >
        <v-menu
          offset-y
          style="position: absolute; right: 10px; top: 10px; z-index: 5"
        >
          <v-toolbar-title slot="activator">
            <v-btn dark primary :color="theme.toolbar.backgroundColorIcon" icon>
              <v-icon>account_circle</v-icon>
            </v-btn>
          </v-toolbar-title>
          <v-list>
            <v-list-tile v-if="user.fullname">
              <v-list-tile-title>
                {{ user.fullname }}
              </v-list-tile-title>
            </v-list-tile>
            <template v-if="user.modules && user.modules.length">
              <v-list-tile
                :key="item.id"
                v-on:click="aCleanSetById(item.dashboardId)"
                v-for="item in user.userModules"
              >
                <v-list-tile-title>
                  <span> {{ item.name }} </span>
                </v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile>
              <v-list-tile-title
                class="link"
                v-on:click="loadChangePassword({ persistent: false })"
              >
                <span> Change Password </span>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ name: 'signin' }">
              <v-list-tile-title>
                <span> Sign out </span>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-layout class="mb-2" row wrap justify-start align-left text-xs-left>
          <v-flex xs12 sm12 fill-height>
            <div
              class="canvas-inner"
              v-if="chart && chart.layout && chart.layout.grids && display"
            >
              <TaybullLayout :chart="chart" :mode="'view'" />
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog fullscreen v-model="loading" full-width>
        <v-container
          fluid
          fill-height
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-layout justify-center align-center>
            <img
              src="https://taybull-public.s3-eu-west-1.amazonaws.com/lg.hexagon-grid-loader.gif"
            />
          </v-layout>
        </v-container>
      </v-dialog>
      <v-dialog
        v-model="changePasswordDialog"
        width="600"
        :persistent="passwordSettings.persistent"
      >
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Change Your Password
          </v-card-title>

          <form id="sign-up-form" @submit.prevent="changePassword()">
            <v-card class="elevation-0">
              <v-card-text>
                <v-text-field
                  id="current_password"
                  v-model="current_password"
                  name="current_password"
                  :error-messages="errors.collect('current_password')"
                  prepend-icon="lock"
                  label="Enter Current Password"
                  type="password"
                  v-validate="'required'"
                  ref="current_password"
                ></v-text-field>
                <v-text-field
                  id="password"
                  v-model="password"
                  name="password"
                  :error-messages="errors.collect('password')"
                  prepend-icon="lock"
                  label="Enter New Password"
                  type="password"
                  v-validate="'required|min:8'"
                  ref="password"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </form>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="passwordSettings.persistent == true"
              flat
              :to="{ name: 'signin' }"
            >
              Sign Out
            </v-btn>
            <v-btn
              v-if="passwordSettings.persistent == false"
              type="submit"
              flat
              @click="changePasswordDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              type="submit"
              color="primary"
              flat
              :loading="loadingChangePassword"
              @click="changePassword()"
            >
              Change Password
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
//import Layers from '@/components/Layers.vue';
//import VueGridLayout from 'vue-grid-layout';
const TaybullLayout = () => import("@/views/Layout.vue");
import dataSources from "@/store/modules/data-sources";
import charts from "@/store/modules/charts";
import UsersService from "@/services/users.service";

import { createNamespacedHelpers } from "vuex";
const chartNamespace = createNamespacedHelpers("charts");
const userNamespace = createNamespacedHelpers("users");

export default {
  name: "dashboards",
  data: function () {
    return {
      changePasswordDialog: false,
      passwordSettings: { persistent: true },
      errorMessage: null,
      loadingChangePassword: false,
      current_password: "",
      password: "",
      subChartId: "now",
      ready: false,
      output: null,
      d: true,
      menuOpen: false,
      fullscreen: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "view",
      timeout: 6000,
      text: "Updated",
    };
  },
  components: {
    //  GridLayout: VueGridLayout.GridLayout,
    //GridItem: VueGridLayout.GridItem,
    TaybullLayout,
    //'layers': Layers
  },
  computed: {
    // ...dataSourceNamespace.mapState(['dataSources']),
    ...userNamespace.mapState({
      user: (state) => state.user,
    }),
    ...chartNamespace.mapState({
      charts: (state) => state.charts,
      dialogFullscreen: (state) => state.fullscreen,
      dialogTitle: (state) => state.dialogTitle,
      display: (state) => state.display,
      dialog: (state) => state.dialog,
      subChartDialog: (state) => state.subChartDialog,
      showGridMenu: (state) => state.showGridMenu,
      chart: (state) => state.chart,
      subChart: (state) => state.subChart,
      activeGrid: (state) => state.activeGrid,
      activeLayer: (state) => state.activeLayer,
      editable: (state) => state.editable,
      loading: (state) => state.loading,
      progressValue: (state) => state.progressValue,
      theme: (state) => state.theme,
    }),
  },
  methods: {
    loadChangePassword(settings) {
      this.changePasswordDialog = true;
      this.passwordSettings = settings;
      // user
    },
    changePassword() {
      const that = this;
      const payload = {
        password: this.password,
        currentPassword: this.current_password,
      };

      that.loadingChangePassword = true;

      this.errorMessage = null;
      this.$validator
        .validateAll()
        .then(async function (response) {
          if (response === true) {
            try {
              const r = await UsersService.changePassword(payload);
              that.notify("Password updated");
              that.loadingChangePassword = false;
              that.changePasswordDialog = false;

              let user = { ...that.user };
              user.reset_password = false;
              that.mSetAuth(user);
            } catch (error) {
              let errorMessage = "Update Error : " + error;

              try {
                const em = error.response.data.message;
                errorMessage = "Update Error : " + em;
              } catch (e1) {}
              // console.log(error.response);
              that.notify(errorMessage);
              // alert(error);
            }

            that.password = "";
            that.current_password = "";
            that.loadingChangePassword = false;
          } else {
            // alert("false");
          }
          that.loadingChangePassword = false;
        })
        .catch(function (e) {
          that.loadingChangePassword = false;
        });
    },
    ...userNamespace.mapMutations(["mSetAuth"]),
    ...chartNamespace.mapMutations([
      "mCloseSubChart",
      "mToggleGridMenu",
      "mSetDialog",
      "mAdd",
      "mSetProjectId",
      "mSetTypeGroup",
      "mSet",
      "mSetName",
      "mToggleEditable",
    ]),
    ...chartNamespace.mapActions([
      "aCreateRandomDashboard",
      "aAdd",
      "aInit",
      "aUpdate",
      "aSet",
      "aCleanSet",
      "aSetById",
      "aCleanSetById",
      "aDelete",
      "aResized",
      "aAddGrid",
      "aActivateGrid",
    ]),
    updateName: function (event) {
      this.mSetName(event.target.innerText);
    },
    toggle() {
      this.$refs["fullscreen"].toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    notify(text) {
      this.snackbar = true;
      this.text = text;
    },
    async print() {
      const el = this.$refs.printMe;
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: "dataURL",
      };
      //this.output = await this.$html2canvas(el, options);
    },
    layoutReadyEvent: function (newLayout) {
      this.ready = true;
      // console.log("Ready layout: ", newLayout)
    },
    checkPasswordChange() {
      const user = this.user;
      if (typeof user.reset_password && user.reset_password == true) {
        this.loadChangePassword({ persistent: true, cancel: false });
      }
    },
  },
  mounted: function () {
    let params = this.$route.params;
    let query = this.$route.query;

    this.mSetProjectId(params.projectId);
    this.mSetTypeGroup("board");
    // console.log("mounted", params);

    // if(typeof query.create != "undefined" && query.create == 'y') {
    //   // this.aCreateRandomDashboard();
    // } else {
    //
    // }

    // console.log("initialise charts");
    this.aInit();

    this.checkPasswordChange();

    const resize = this.aResized;
    setTimeout(function () {
      resize();
    }, 1000);
  },
  beforeCreate: function () {
    if (typeof this.$store.state["dataSources"] == "undefined") {
      this.$store.registerModule("dataSources", dataSources);
    }
    if (typeof this.$store.state["charts"] == "undefined") {
      this.$store.registerModule("charts", charts);
    }
  },
  beforeDestroy() {},
  startRefresh() {
    if (
      typeof parameters.refreshInterval != "undefined" &&
      parameters.refreshInterval &&
      parameters.refreshQuery != "undefined" &&
      parameters.refreshQuery
    ) {
      let refrestInterval = parseInt(parameters.refreshInterval.value) * 1000;
      let refreshQuery = parameters.refreshQuery.value;

      let params = {};
      let progress = false;
      // console.log("refreshQuery", refreshQuery);
      params.sql = window.btoa(refreshQuery);
      params.pre = 1;
      params.totalItems = 1;
      params.rowsPerPage = 1;

      if (isNaN(refrestInterval)) {
        return;
      }

      if (refrestInterval < 60000) {
        refrestInterval = 60000;
        //console.log(refrestInterval);
        //return;
      }

      that.interval = setInterval(function () {
        if (progress == true) {
          console.log("update check already in progress");
          return false;
        }
        progress = true;
        ApiService.query("/datasource/sql/" + 979, {
          params: params,
        })
          .then(function (response) {
            progress = false;
            let data = response.data;

            if (data.results.length > 0) {
              let lastChange = Object.values(data.results[0])[0];

              if (lastUpdated == lastChange) {
                console.log("no changes detected");
              } else if (lastUpdated == null) {
                lastUpdated = lastChange;
              } else if (lastUpdated != lastChange) {
                console.log(
                  chart.type +
                    "updating new change pervious:" +
                    lastUpdated +
                    " ;now:" +
                    lastChange
                );
                lastUpdated = lastChange;
                // chart.setLightUpdate(true);
                // chart.hydrate();
              }
            }
          })
          .catch(function (error) {
            progress = false;
          });
        // console.log("refreshing");
      }, refrestInterval);
    }
  },
};
</script>
